
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { TextField } from '@mui/material';
import numeral from 'numeral';

import { ErrorMsg } from './ErrorMsg' // eslint-disable-line

export default function DollarPercent({
  value, onChange, total,
}) {
  const [percentage, setPercentage] = useState(typeof (value) === 'number' && total ? Math.round(value * 100 / total) : '');
  const [error, setError] = useState();

  const handleChangeValue = useCallback(event => {
    const number = makeNumber(event.target.value);
    if (number > total) {
      setError(`Amount must not exceed $${numeral(total).format(0, 0)}`);
    } else {
      setError();
    }
    const percentage = Math.round((number / total) * 100);
    setPercentage(percentage);
    onChange(number);
  }, [onChange, value, setPercentage, total]);

  const handleChangePercent = useCallback(event => {
    const val = event.target.value;
    const percentage = parseInt(val || 0);
    if (percentage > 100) return;
    const calc = Math.round((percentage * total) / 100);
    setPercentage(val);
    onChange(calc);
  }, [value, total, onChange, setPercentage]);

  return <div>
    <SubContainer>
      $<Field
        value={typeof (value) === 'number' ? numeral(value).format(0, 0) : ''}
        onChange={handleChangeValue}
        width={100}
      />
      &nbsp;or&nbsp;
      <Field
        disabled={!total}
        value={percentage}
        onChange={handleChangePercent}
        width={100}
      />% of total program cost
    </SubContainer>
    {error && <ErrorMsg error={error} />}
  </div>;
}

const SubContainer = styled.div`
  margin-left: 30px;
  display: flex;
  align-items: center;
  font-size: 16px;
`;

const Field = styled(TextField)`
  width: ${({ width }) => width}px;
`;

const makeNumber = n => n && parseInt(String(n).replace(/\,/g, ''));